
<script lang="ts" setup>
import { ref, computed } from 'vue';
import { useRouter } from 'vue-router';
import { useFormsStore } from "@/tiers/frontend/stores/FormsStore"

const router = useRouter()
const store = useFormsStore()
const forms = computed(() => store.forms)

const direct = (name: string, title: string) => {
    router.push({ name, params: { 'title': title } })
}

const generateTitle = (title: string) => {
    return title.replace(/ /g, "-").toLowerCase();
}

</script>
<template>
    <h1 class="title">Let's do wonderful things together!</h1>
    <p class="excerpt">Help us to find out your need. Select one of the services to make it short for you.</p>
    <div class="row">
        <template v-if="forms.length > 0" v-for="(form, i) in forms" :key="i">
            <template v-if="form.status == 'active'">
                <div class="col col-6 col-md-3">
                    <div class="cont">
                        <h2>{{ form.local.title }}
                            <div class="hover">
                                <h3>{{ form.local.title }}</h3>
                                <p>{{ form.attrs.description }}</p>
                            </div>
                        </h2>
                        <a @click="direct('form', generateTitle(form.local.title))">Let me in</a>
                    </div>
                </div>
            </template>
        </template>
    </div>
    <p class="italic">After filling the form, we will revise your requirements and contact you on your email or phone
        number to schedule a meeting and go through all details.</p>
</template>